var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame41223(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 127,
    viewBox: "0 0 47 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.1838,
    y: 86.3419,
    width: 45.6838,
    height: 45.6838,
    rx: 22.75,
    transform: "rotate(-180 46.1838 86.3419)",
    fill: "#007367"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1838,
    y: 86.3419,
    width: 45.6838,
    height: 45.6838,
    rx: 22.75,
    transform: "rotate(-180 46.1838 86.3419)",
    stroke: "#007367"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3569 68.4753L18.3614 67.4797L22.3437 63.4974L18.3614 59.515L19.3569 58.5195L23.3393 62.5018L27.3216 58.5195L28.3172 59.515L24.3349 63.4974L28.3172 67.4797L27.3216 68.4753L23.3393 64.493L19.3569 68.4753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame41223);
export default __webpack_public_path__ + "static/media/frame-41223.107fa47f21e7129cf2d2c9200ed11f64.svg";
export { ForwardRef as ReactComponent };